import { IconBrandInstagram, IconBrandTiktok, IconBrandYoutube } from '@tabler/icons-react';

// Creator accounts are `social_accounts: [{ platform, handle }]` (one per platform) since contract 1.2.0.
export const STUDIO_PLATFORMS = ['instagram', 'tiktok', 'youtube'];
// Brand names, the same in every language.
export const PLATFORM_LABELS = { instagram: 'Instagram', tiktok: 'TikTok', youtube: 'YouTube' };
export const PLATFORM_ICONS = { instagram: IconBrandInstagram, tiktok: IconBrandTiktok, youtube: IconBrandYoutube };

// Public handle rules of each platform, without the leading `@` (core-platform
// `SocialPlatform::handlePattern`).
const HANDLE_PATTERNS = {
  instagram: /^[A-Za-z0-9._]{1,30}$/,
  tiktok: /^[A-Za-z0-9._]{2,24}$/,
  youtube: /^[A-Za-z0-9._-]{3,30}$/,
};

export const accountHandle = (creator, platform = 'instagram') =>
  creator?.social_accounts?.find(account => account.platform === platform)?.handle || '';

// Replaces one platform's handle and keeps the others; an empty handle removes that account.
export const withAccount = (accounts = [], platform, handle) => {
  const others = accounts.filter(account => account.platform !== platform);
  const clean = (handle || '').trim().replace(/^@/, '');
  return clean ? [...others, { platform, handle: clean }] : others;
};

// `@Handle`, ` handle ` or a pasted profile URL (instagram.com/handle/?hl=pt) →
// `handle`; null when the result breaks the platform's rules.
export const normalizeHandle = (raw, platform = 'instagram') => {
  let value = (raw || '').trim();
  const url = value.match(/^(?:https?:\/\/)?(?:www\.|m\.)?[a-z0-9.-]+\.[a-z]{2,}\/@?([^/?#\s]+)/i);
  if (url) value = url[1];
  value = value.replace(/^@+/, '').replace(/\/+$/, '').toLowerCase();
  return HANDLE_PATTERNS[platform]?.test(value) ? value : null;
};
